import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get('token');
    const { checkAuth } = useAuth();
    const [status, setStatus] = useState('verifying'); // verifying | success | error

    useEffect(() => {
        const run = async () => {
            if (!token) {
                setStatus('error');
                return;
            }
            try {
                await axios.post(`${API}/auth/verify`, { token }, { withCredentials: true });
                setStatus('success');
                checkAuth();
            } catch (e) {
                setStatus('error');
            }
        };
        run();
    }, [token, checkAuth]);

    return (
        <div className="min-h-[70vh] bg-[#F8F9FA] flex items-center justify-center px-4 py-16">
            <div className="bg-white rounded-2xl shadow-soft p-8 max-w-md w-full text-center" data-testid="verify-email-card">
                {status === 'verifying' && (
                    <>
                        <Loader2 className="w-12 h-12 text-[#1B4D3E] animate-spin mx-auto mb-4" />
                        <h1 className="text-2xl font-bold text-slate-900">Verifying your email…</h1>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <CheckCircle2 className="w-14 h-14 text-green-600 mx-auto mb-4" />
                        <h1 className="text-2xl font-bold text-slate-900 mb-2" data-testid="verify-success">Email verified!</h1>
                        <p className="text-slate-500 mb-6">Your account is all set. You can start shopping now.</p>
                        <Link to="/shop">
                            <button className="btn-primary px-6 py-3 rounded-full" data-testid="verify-shop-btn">Start Shopping</button>
                        </Link>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" />
                        <h1 className="text-2xl font-bold text-slate-900 mb-2" data-testid="verify-error">Verification failed</h1>
                        <p className="text-slate-500 mb-6">This link is invalid or has expired. Please sign in and request a new verification email.</p>
                        <Link to="/login">
                            <button className="btn-primary px-6 py-3 rounded-full" data-testid="verify-login-btn">Go to Login</button>
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
